import type { SvgProps } from '@main/core-ui/src/Icon/constants/enums';
import React from 'react';

export const LanguageCharacters: React.FC<SvgProps> = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.25065 3.33398V5.83398"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.0827 16.666L13.7493 9.16602L10.416 16.666"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.1582 15.0007H16.3415"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.91602 12.5007C6.32852 12.2307 9.31268 9.24648 9.58352 5.83398H2.91685"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.58268 12.5007C7.45018 12.3323 5.58435 10.4665 5.41602 8.33398"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
